import ajax from './../ajax';

export function getCourseLevels(courseKey) {
  return ajax(`/courses/${courseKey}/show_course_levels_by_course_key`, {
    method: 'GET'
  });
}

export function getCourseLevelLiveProject(courseLevelId) {
  return ajax(`/course_level/${courseLevelId}/live_projects`);
}

export function getCourseLevelInternship(courseLevelId) {
  return ajax(`/course_levels/${courseLevelId}/internship_companies`);
}



// WEBPACK FOOTER //
// ./src/api/v1/courseLevel.js